import React from "react"
import PropTypes from "prop-types"

const DropdownWithSelectAll = ({ menu, showSelectAll, onSelectAll, label }) => {
  return (
    <>
      {showSelectAll && (
        <button
          type="button"
          style={{
            padding: "8px",
            fontWeight: "bold",
            borderBottom: "1px solid #f0f0f0",
            background: "none",
            border: "none",
            cursor: "pointer",
            width: "100%",
            textAlign: "left",
          }}
          onClick={onSelectAll}
        >
          {label}
        </button>
      )}
      {menu}
    </>
  )
}

DropdownWithSelectAll.propTypes = {
  menu: PropTypes.any,
  showSelectAll: PropTypes.bool,
  onSelectAll: PropTypes.func,
  label: PropTypes.string,
}

export default DropdownWithSelectAll
